export const environment = {
  production: true,
  apiUrl: 'https://sabiq-backend-prod.azurewebsites.net/api'
};
